import { render, staticRenderFns } from "./Paginacion.vue?vue&type=template&id=09606011&"
import script from "./Paginacion.vue?vue&type=script&lang=js&"
export * from "./Paginacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports